import React, { useState, useRef, useContext, useEffect } from 'react';
import axios from 'axios';
import { Form, Table, Pagination } from 'react-bootstrap';
import AppContext from '../../../../context/AppContext';
import '../../../../assests/css/admin/SubAdminManagement/SubAdminManagement.css';


// ================================================================
//  SUB ADMIN ADD
// ================================================================
const SubAdminAdd = ({ onBack, onSave }) => {
  const { baseUrl, regExpChecker } = useContext(AppContext);

  const [firstName, setFirstName]                     = useState('');
  const [lastName, setLastName]                       = useState('');
  const [email, setEmail]                             = useState('');
  const [phone, setPhone]                             = useState('');
  const [password, setPassword]                       = useState('');
  const [confirmPassword, setConfirmPassword]         = useState('');
  const [isActive, setIsActive]                       = useState(true);
  const [isSuperAdmin, setIsSuperAdmin]               = useState(false);
  const [profilePreview, setProfilePreview]           = useState(null);
  const [showPassword, setShowPassword]               = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading]                         = useState(false);
  const [errors, setErrors]                           = useState({});

  const fileInputRef = useRef(null);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setProfilePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const validateField = (name, value) => {
    let error = '';
    if (name === 'firstName')       error = regExpChecker('firstname', value) || '';
    if (name === 'lastName')        error = regExpChecker('lastname',  value) || '';
    if (name === 'email')           error = regExpChecker('email',     value) || '';
    if (name === 'password')        error = regExpChecker('password',  value) || '';
    if (name === 'confirmPassword') error = value !== password ? 'Passwords do not match' : '';
    setErrors(prev => ({ ...prev, [name]: error }));
  };


  const validateForm = () => {
    const newErrors = {};
    const firstnameErr = regExpChecker('firstname', firstName); if (firstnameErr) newErrors.firstName = firstnameErr;
    const lastnameErr  = regExpChecker('lastname',  lastName);  if (lastnameErr)  newErrors.lastName  = lastnameErr;
    const emailErr     = regExpChecker('email',     email);     if (emailErr)     newErrors.email     = emailErr;
    const passwordErr  = regExpChecker('password',  password);  if (passwordErr)  newErrors.password  = passwordErr;
    if (!confirmPassword.trim())           newErrors.confirmPassword = 'Please confirm your password';
    else if (password !== confirmPassword) newErrors.confirmPassword = 'Passwords do not match';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const renderError = (field) => {
    if (!errors[field]) return null;
    return <div style={{ color: 'red', fontSize: '0.78rem', marginTop: '4px' }}>{errors[field]}</div>;
  };

  const createSubAdmin = () => {
    const formData = new FormData();
    formData.append('firstname',     firstName);
    formData.append('lastname',      lastName);
    formData.append('email',         email);
    formData.append('phone',         phone);
    formData.append('password',      password);
    formData.append('issuperadmin', isSuperAdmin ? '1' : '0');
    formData.append('status',        isActive ? 'active' : 'inactive');
    const file = fileInputRef.current?.files[0];
    if (file) formData.append('profile_image', file);

        setLoading(true);
    axios.post(`${baseUrl}/admin/subadmin/createSubAdmin`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(() => {
        setLoading(false);
        if (onSave) onSave();
        if (onBack) onBack();
      })
      .catch((error) => {
        setLoading(false);
        alert(error?.response?.data?.message || 'Something went wrong. Please try again.');
      });
    
    };
  const handleSubmit = () => {
    if (!validateForm()) return;
    if (window.confirm(`Are you sure you want to create ${firstName} ${lastName} as a sub-admin?`)) {
      createSubAdmin();
    }
  };

  const handleCancel = () => {
    if (window.confirm('Are you sure you want to cancel? All changes will be lost.')) {
      if (onBack) onBack();
    }
  };

  const displayName  = firstName && lastName ? `${firstName} ${lastName}` : 'New Sub-Admin';
  const displayEmail = email || 'Upload profile photo';

  return (
    <div className="Sub-Admin-SubAdmin-add-container">

      <div className="Sub-Admin-SubAdmin-add-header">
        <button className="Sub-Admin-SubAdmin-back-btn" onClick={handleCancel}>
          ← Add New Sub-Admin
        </button>
      </div>

      <div className="Sub-Admin-SubAdmin-status-card Sub-Admin-SubAdmin-status-active">
        <div className="Sub-Admin-SubAdmin-status-icon">✓</div>
        <div className="Sub-Admin-SubAdmin-status-content">
          <div className="Sub-Admin-SubAdmin-status-title">Account Status: {isActive ? 'Active' : 'Inactive'}</div>
          <div className="Sub-Admin-SubAdmin-status-subtitle">This sub-admin has full access to their assigned permissions</div>
        </div>
        <label className="Sub-Admin-SubAdmin-toggle">
          <input type="checkbox" checked={isActive} onChange={(e) => setIsActive(e.target.checked)} />
          <span className="Sub-Admin-SubAdmin-toggle-slider"></span>
        </label>
      </div>

      <div className="Sub-Admin-SubAdmin-section-card">
        <div className="Sub-Admin-SubAdmin-section-header">
          <span className="Sub-Admin-SubAdmin-section-icon">👤</span>
          <h2 className="Sub-Admin-SubAdmin-section-title">Basic Information</h2>
        </div>

        <div className="Sub-Admin-SubAdmin-profile-upload">
          <div className="Sub-Admin-SubAdmin-profile-avatar">
            {profilePreview ? (
              <img src={profilePreview} alt="Profile" style={{ width: '80px', height: '80px', borderRadius: '50%', objectFit: 'cover' }} />
            ) : (
              <div className="Sub-Admin-SubAdmin-profile-placeholder">
                <span className="Sub-Admin-SubAdmin-placeholder-icon">👤</span>
              </div>
            )}
            <input ref={fileInputRef} type="file" accept="image/*" onChange={handleImageUpload} style={{ display: 'none' }} />
            <button className="Sub-Admin-SubAdmin-camera-btn" onClick={() => fileInputRef.current?.click()} type="button">📷</button>
          </div>
          <div>
            <div className="Sub-Admin-SubAdmin-profile-title">{displayName}</div>
            <div className="Sub-Admin-SubAdmin-profile-subtitle">{displayEmail}</div>
          </div>
        </div>

        <div className="Sub-Admin-SubAdmin-form-grid">

          <div className="Sub-Admin-SubAdmin-form-group">
            <label className="Sub-Admin-SubAdmin-label">First Name <span className="Sub-Admin-SubAdmin-required">*</span></label>
            <Form.Control
              type="text" value={firstName}
              onChange={(e) => { setFirstName(e.target.value); validateField('firstName', e.target.value); }}
              placeholder="e.g. John"
              className={`Sub-Admin-SubAdmin-input ${errors.firstName ? 'is-invalid' : ''}`}
            />
            {renderError('firstName')}
          </div>

          <div className="Sub-Admin-SubAdmin-form-group">
            <label className="Sub-Admin-SubAdmin-label">Last Name <span className="Sub-Admin-SubAdmin-required">*</span></label>
            <Form.Control
              type="text" value={lastName}
              onChange={(e) => { setLastName(e.target.value); validateField('lastName', e.target.value); }}
              placeholder="e.g. Doe"
              className={`Sub-Admin-SubAdmin-input ${errors.lastName ? 'is-invalid' : ''}`}
            />
            {renderError('lastName')}
          </div>

          <div className="Sub-Admin-SubAdmin-form-group">
            <label className="Sub-Admin-SubAdmin-label">Email Address <span className="Sub-Admin-SubAdmin-required">*</span></label>
            <Form.Control
              type="email" value={email}
              onChange={(e) => { setEmail(e.target.value); validateField('email', e.target.value); }}
              placeholder="e.g. john@example.com"
              className={`Sub-Admin-SubAdmin-input ${errors.email ? 'is-invalid' : ''}`}
            />
            {renderError('email')}
          </div>

          <div className="Sub-Admin-SubAdmin-form-group">
            <label className="Sub-Admin-SubAdmin-label">Phone Number</label>
            <Form.Control
              type="tel" value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="+1 (000) 000-0000"
              className="Sub-Admin-SubAdmin-input"
            />
          </div>

          <div className="Sub-Admin-SubAdmin-form-group">
            <label className="Sub-Admin-SubAdmin-label">Password <span className="Sub-Admin-SubAdmin-required">*</span></label>
            <div className="Sub-Admin-SubAdmin-password-wrapper">
              <Form.Control
                type={showPassword ? 'text' : 'password'} value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  validateField('password', e.target.value);
                  if (confirmPassword) {
                    setErrors(prev => ({
                      ...prev,
                      confirmPassword: e.target.value !== confirmPassword ? 'Passwords do not match' : ''
                    }));
                  }
                }}
                placeholder="••••••••"
                className={`Sub-Admin-SubAdmin-input ${errors.password ? 'is-invalid' : ''}`}
              />
              <button type="button" className="Sub-Admin-SubAdmin-eye-icon" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
            {renderError('password')}
          </div>

          <div className="Sub-Admin-SubAdmin-form-group">
            <label className="Sub-Admin-SubAdmin-label">Confirm Password <span className="Sub-Admin-SubAdmin-required">*</span></label>
            <div className="Sub-Admin-SubAdmin-password-wrapper">
              <Form.Control
                type={showConfirmPassword ? 'text' : 'password'} value={confirmPassword}
                onChange={(e) => { setConfirmPassword(e.target.value); validateField('confirmPassword', e.target.value); }}
                placeholder="••••••••"
                className={`Sub-Admin-SubAdmin-input ${errors.confirmPassword ? 'is-invalid' : ''}`}
              />
              <button type="button" className="Sub-Admin-SubAdmin-eye-icon" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                {showConfirmPassword ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
            {renderError('confirmPassword')}
          </div>

          <div className="Sub-Admin-SubAdmin-form-group">
            <label className="Sub-Admin-SubAdmin-label">Super Admin</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginTop: '0.5rem' }}>
              <label className="Sub-Admin-SubAdmin-toggle">
                <input type="checkbox" checked={isSuperAdmin} onChange={(e) => setIsSuperAdmin(e.target.checked)} />
                <span className="Sub-Admin-SubAdmin-toggle-slider"></span>
              </label>
              <span style={{ fontSize: '0.875rem', color: 'var(--text-secondary)' }}>
                {isSuperAdmin ? 'Super Admin Access (1)' : 'Regular Access (0)'}
              </span>
            </div>
          </div>

        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.75rem', marginTop: '1.5rem', marginBottom: '1.5rem' }}>
        <button className="Sub-Admin-SubAdmin-cancel-btn" onClick={handleCancel}>Cancel</button>
        <button className="Sub-Admin-SubAdmin-save-btn" onClick={handleSubmit} disabled={loading}>
          <span>💾</span> {loading ? 'Creating...' : 'Create Sub-Admin'}
        </button>
      </div>

    </div>
  );
};


// ================================================================
//  SUB ADMIN EDIT
// ================================================================
const SubAdminEdit = ({ admin, onBack, onSave }) => {
  const { baseUrl, baseUrlForFiles, regExpChecker } = useContext(AppContext);

  const [firstName, setFirstName]                     = useState(admin?.firstname || '');
  const [lastName, setLastName]                       = useState(admin?.lastname || '');
  const [email, setEmail]                             = useState(admin?.email || '');
  const [phone, setPhone]                             = useState(admin?.phone || '');
  const [password, setPassword]                       = useState('');
  const [confirmPassword, setConfirmPassword]         = useState('');
  const [isSuperAdmin, setIsSuperAdmin]               = useState(admin?.issuperadmin == 1);
  const [isActive, setIsActive]                       = useState(admin?.status === 'active');
  const [errors, setErrors]                           = useState({});

  const [profilePreview, setProfilePreview] = useState(
    admin?.profile_image ? `${baseUrlForFiles}/${admin.profile_image}` : null
  );

  const [showPassword, setShowPassword]               = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading]                         = useState(false);

  const fileInputRef = useRef(null);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setProfilePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };


  const validateField = (name, value) => {
    let error = '';
    if (name === 'firstName')       error = regExpChecker('firstname', value) || '';
    if (name === 'lastName')        error = regExpChecker('lastname',  value) || '';
    if (name === 'email')           error = regExpChecker('email',     value) || '';
    if (name === 'password')        error = regExpChecker('password',  value) || '';
    if (name === 'confirmPassword') error = value !== password ? 'Passwords do not match' : '';
    setErrors(prev => ({ ...prev, [name]: error }));
  };

  const validateForm = () => {
    const newErrors = {};
    const firstnameErr = regExpChecker('firstname', firstName); if (firstnameErr) newErrors.firstName = firstnameErr;
    const lastnameErr  = regExpChecker('lastname',  lastName);  if (lastnameErr)  newErrors.lastName  = lastnameErr;
    const emailErr     = regExpChecker('email',     email);     if (emailErr)     newErrors.email     = emailErr;
    if (password) {
      const passwordErr = regExpChecker('password', password); if (passwordErr) newErrors.password = passwordErr;
      if (password !== confirmPassword) newErrors.confirmPassword = 'Passwords do not match';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const renderError = (field) => {
    if (!errors[field]) return null;
    return <div style={{ color: 'red', fontSize: '0.78rem', marginTop: '4px' }}>{errors[field]}</div>;
  };

  const updateSubAdmin = () => {
    const formData = new FormData();
    formData.append('firstname',     firstName);
    formData.append('lastname',      lastName);
    formData.append('email',         email);
    formData.append('phone',         phone);
    formData.append('issuperadmin', isSuperAdmin ? '1' : '0');
    formData.append('status',        isActive ? 'active' : 'inactive');
    if (password) formData.append('password', password);
    const file = fileInputRef.current?.files[0];
    if (file) formData.append('profile_image', file);

    setLoading(true);
    axios.post(`${baseUrl}/admin/subadmin/updateSubAdmin/${admin.id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then((response) => {
        setLoading(false);
        console.log(response.data);
        if (onSave) onSave();
        if (onBack) onBack();
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        alert(error?.response?.data?.message || 'Something went wrong. Please try again.');
      });
  };

  const handleSubmit = () => {
    if (!validateForm()) return;
    if (window.confirm(`Are you sure you want to save changes for ${firstName} ${lastName}?`)) {
      updateSubAdmin();
    }
  };

  const handleCancel = () => {
    if (window.confirm('Are you sure you want to cancel? All unsaved changes will be lost.')) {
      if (onBack) onBack();
    }
  };

  return (
    <div className="Sub-Admin-SubAdmin-edit-container">

      <div className="Sub-Admin-SubAdmin-edit-header">
        <button className="Sub-Admin-SubAdmin-back-btn" onClick={handleCancel}>
          ← Edit Sub-Admin Details
        </button>
      </div>

      <div className="Sub-Admin-SubAdmin-status-card Sub-Admin-SubAdmin-status-active">
        <div className="Sub-Admin-SubAdmin-status-icon">✓</div>
        <div className="Sub-Admin-SubAdmin-status-content">
          <div className="Sub-Admin-SubAdmin-status-title">Account Status: {isActive ? 'Active' : 'Inactive'}</div>
          <div className="Sub-Admin-SubAdmin-status-subtitle">This sub-admin has full access to their assigned permissions</div>
        </div>
        <label className="Sub-Admin-SubAdmin-toggle">
          <input type="checkbox" checked={isActive} onChange={(e) => setIsActive(e.target.checked)} />
          <span className="Sub-Admin-SubAdmin-toggle-slider"></span>
        </label>
      </div>

      <div className="Sub-Admin-SubAdmin-section-card">
        <div className="Sub-Admin-SubAdmin-section-header">
          <span className="Sub-Admin-SubAdmin-section-icon">👤</span>
          <h2 className="Sub-Admin-SubAdmin-section-title">Basic Information</h2>
        </div>

        <div className="Sub-Admin-SubAdmin-profile-section">
          <div className="Sub-Admin-SubAdmin-profile-avatar">
            {profilePreview ? (
              <img src={profilePreview} alt="Profile" style={{ width: '90px', height: '90px', borderRadius: '50%', objectFit: 'cover' }} onError={(e) => { e.target.style.display = 'none'; }} />
            ) : (
              <div className="Sub-Admin-SubAdmin-avatar-emoji">👤</div>
            )}
            <input ref={fileInputRef} type="file" accept="image/*" onChange={handleImageUpload} style={{ display: 'none' }} />
            <button className="Sub-Admin-SubAdmin-upload-btn" onClick={() => fileInputRef.current?.click()} type="button">📷</button>
          </div>
          <div className="Sub-Admin-SubAdmin-profile-details">
            <div className="Sub-Admin-SubAdmin-profile-name">{firstName} {lastName}</div>
            <div className="Sub-Admin-SubAdmin-profile-activity">Last active: {admin?.lastActivity || '2 hours ago'}</div>
          </div>
        </div>

        <div className="Sub-Admin-SubAdmin-form-grid">

          <div className="Sub-Admin-SubAdmin-form-group">
            <label className="Sub-Admin-SubAdmin-label">First Name <span className="Sub-Admin-SubAdmin-required">*</span></label>
            <Form.Control
              type="text" value={firstName}
              onChange={(e) => { setFirstName(e.target.value); validateField('firstName', e.target.value); }}
              placeholder="e.g. John"
              className={`Sub-Admin-SubAdmin-input ${errors.firstName ? 'is-invalid' : ''}`}
            />
            {renderError('firstName')}
          </div>

          <div className="Sub-Admin-SubAdmin-form-group">
            <label className="Sub-Admin-SubAdmin-label">Last Name <span className="Sub-Admin-SubAdmin-required">*</span></label>
            <Form.Control
              type="text" value={lastName}
              onChange={(e) => { setLastName(e.target.value); validateField('lastName', e.target.value); }}
              placeholder="e.g. Doe"
              className={`Sub-Admin-SubAdmin-input ${errors.lastName ? 'is-invalid' : ''}`}
            />
            {renderError('lastName')}
          </div>

          <div className="Sub-Admin-SubAdmin-form-group">
            <label className="Sub-Admin-SubAdmin-label">Email Address <span className="Sub-Admin-SubAdmin-required">*</span></label>
            <Form.Control
              type="email" value={email}
              onChange={(e) => { setEmail(e.target.value); validateField('email', e.target.value); }}
              placeholder="e.g. john@example.com"
              className={`Sub-Admin-SubAdmin-input ${errors.email ? 'is-invalid' : ''}`}
            />
            {renderError('email')}
          </div>

          <div className="Sub-Admin-SubAdmin-form-group">
            <label className="Sub-Admin-SubAdmin-label">Phone Number</label>
            <Form.Control
              type="tel" value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="+1 (000) 000-0000"
              className="Sub-Admin-SubAdmin-input"
            />
          </div>

          <div className="Sub-Admin-SubAdmin-form-group">
            <label className="Sub-Admin-SubAdmin-label">New Password <span className="Sub-Admin-SubAdmin-optional">(optional)</span></label>
            <div className="Sub-Admin-SubAdmin-password-wrapper">
              <Form.Control
                type={showPassword ? 'text' : 'password'} value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  validateField('password', e.target.value);
                  if (confirmPassword) {
                    setErrors(prev => ({
                      ...prev,
                      confirmPassword: e.target.value !== confirmPassword ? 'Passwords do not match' : ''
                    }));
                  }
                }}
                placeholder="Leave blank to keep current"
                className={`Sub-Admin-SubAdmin-input ${errors.password ? 'is-invalid' : ''}`}
              />
              <button type="button" className="Sub-Admin-SubAdmin-eye-icon" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
            {renderError('password')}
          </div>

          <div className="Sub-Admin-SubAdmin-form-group">
            <label className="Sub-Admin-SubAdmin-label">Confirm Password</label>
            <div className="Sub-Admin-SubAdmin-password-wrapper">
              <Form.Control
                type={showConfirmPassword ? 'text' : 'password'} value={confirmPassword}
                onChange={(e) => { setConfirmPassword(e.target.value); validateField('confirmPassword', e.target.value); }}
                placeholder="••••••••"
                className={`Sub-Admin-SubAdmin-input ${errors.confirmPassword ? 'is-invalid' : ''}`}
              />
              <button type="button" className="Sub-Admin-SubAdmin-eye-icon" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                {showConfirmPassword ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
            {renderError('confirmPassword')}
          </div>

          <div className="Sub-Admin-SubAdmin-form-group">
            <label className="Sub-Admin-SubAdmin-label">Super Admin</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginTop: '0.5rem' }}>
              <label className="Sub-Admin-SubAdmin-toggle">
                <input type="checkbox" checked={isSuperAdmin} onChange={(e) => setIsSuperAdmin(e.target.checked)} />
                <span className="Sub-Admin-SubAdmin-toggle-slider"></span>
              </label>
              <span style={{ fontSize: '0.875rem', color: 'var(--text-secondary)' }}>
                {isSuperAdmin ? 'Super Admin Access (1)' : 'Regular Access (0)'}
              </span>
            </div>
          </div>

        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.75rem', marginTop: '1.5rem', marginBottom: '1.5rem' }}>
        <button className="Sub-Admin-SubAdmin-cancel-btn" onClick={handleCancel}>Cancel</button>
        <button className="Sub-Admin-SubAdmin-save-btn" onClick={handleSubmit} disabled={loading}>
          <span>💾</span> {loading ? 'Saving...' : 'Save Changes'}
        </button>
      </div>

    </div>
  );
};


// ================================================================
//  SUB ADMIN LIST
// ================================================================
const SubAdminList = ({ onEdit, onAdd }) => {
  const { baseUrl, baseUrlForFiles } = useContext(AppContext);


  const [subAdmins, setSubAdmins]   = useState([]);
  const [loading, setLoading]       = useState(false);
  const [activeTab, setActiveTab]   = useState('all');


  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 4;

    const viewAllSubAdmins = () => {
    setLoading(true);
    axios.get(`${baseUrl}/admin/subadmin/viewAllSubAdmins`)
      .then((response) => {
        setLoading(false);
        setSubAdmins(response.data.success && response.data.data ? response.data.data : []);
      })
      .catch(() => {
        setLoading(false);
        setSubAdmins([]);
      });
  };

  useEffect(() => { viewAllSubAdmins(); }, []);

    const toggleStatus = (id, isCurrentlyActive) => {
    const formData = new FormData();
    formData.append('status', isCurrentlyActive ? 'inactive' : 'active');
    axios.post(`${baseUrl}/admin/subadmin/updateSubAdmin/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(() => viewAllSubAdmins())
      .catch(() => alert('Could not update status. Please try again.'));
  };

  const deleteSubAdmin = (id) => {
    if (!window.confirm('Are you sure you want to delete this sub-admin?')) return;

    const formData = new FormData();
    formData.append('id', id);
    axios.post(`${baseUrl}/admin/subadmin/deleteSubAdmin`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(() => viewAllSubAdmins())
      .catch(() => alert('Could not delete sub-admin. Please try again.'));
  };

  const filteredAdmins = subAdmins.filter((admin) => {
    if (activeTab === 'active')   return admin.status === 'active';
    if (activeTab === 'inactive') return admin.status !== 'active';
    return true;
  });

  const totalPages    = Math.ceil(filteredAdmins.length / itemsPerPage);
  const startIndex    = (currentPage - 1) * itemsPerPage;
  const currentAdmins = filteredAdmins.slice(startIndex, startIndex + itemsPerPage);

  const handleTabChange = (tab) => { setActiveTab(tab); setCurrentPage(1); };

  const getPageNumbers = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else if (currentPage <= 3) {
      pages.push(1, 2, 3, '...', totalPages);
    } else if (currentPage >= totalPages - 2) {
      pages.push(1, '...', totalPages - 2, totalPages - 1, totalPages);
    } else {
      pages.push(1, '...', currentPage, '...', totalPages);
    }
    return pages;
  };

  const getImageUrl = (imagePath) => `${baseUrlForFiles}/${imagePath}`;

  return (
    <div className="Sub-Admin-SubAdmin-list-container">

      <div className="Sub-Admin-SubAdmin-header">
        <div>
          <h1 className="Sub-Admin-SubAdmin-title">Sub-Admin Management</h1>
          <p className="Sub-Admin-SubAdmin-subtitle">Manage permissions and access levels for your team.</p>
        </div>
        <button className="Sub-Admin-SubAdmin-btn-primary" onClick={onAdd}>
          <span className="Sub-Admin-SubAdmin-btn-icon">+</span> Add New Sub-Admin
        </button>
      </div>

      <div className="Sub-Admin-SubAdmin-tabs">
        <button className={`Sub-Admin-SubAdmin-tab ${activeTab === 'all'      ? 'Sub-Admin-SubAdmin-tab-active' : ''}`} onClick={() => handleTabChange('all')}>All ({subAdmins.length})</button>
        <button className={`Sub-Admin-SubAdmin-tab ${activeTab === 'active'   ? 'Sub-Admin-SubAdmin-tab-active' : ''}`} onClick={() => handleTabChange('active')}>Active ({subAdmins.filter((a) => a.status === 'active').length})</button>
        <button className={`Sub-Admin-SubAdmin-tab ${activeTab === 'inactive' ? 'Sub-Admin-SubAdmin-tab-active' : ''}`} onClick={() => handleTabChange('inactive')}>Inactive ({subAdmins.filter((a) => a.status !== 'active').length})</button>
      </div>

      <div className="Sub-Admin-SubAdmin-table-container">
        <Table className="Sub-Admin-SubAdmin-table">
          <thead>
            <tr>
              <th>SUB-ADMIN PROFILE</th>
              <th>SUB-ADMIN NAME</th>
              <th>EMAIL</th>
              <th>STATUS</th>
              <th>ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="5" className="Sub-Admin-SubAdmin-no-data">Loading...</td></tr>
            ) : currentAdmins.length > 0 ? (
              currentAdmins.map((admin) => {
                const isActive = admin.status === 'active';
                const fullName = `${admin.firstname || ''} ${admin.lastname || ''}`.trim();
                return (
                  <tr key={admin.id} className="Sub-Admin-SubAdmin-table-row">
                    <td>
                      <div className="Sub-Admin-SubAdmin-avatar-container">
                        <div className="Sub-Admin-SubAdmin-avatar">
                          {admin.profile_image ? (
                            <img src={getImageUrl(admin.profile_image)} alt={fullName} className="Sub-Admin-SubAdmin-avatar-img" onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }} />
                          ) : null}
                          {!admin.profile_image && <span>👤</span>}
                        </div>
                      </div>
                    </td>
                    <td><div className="Sub-Admin-SubAdmin-user-name">{fullName}</div></td>
                    <td><div className="Sub-Admin-SubAdmin-user-email">{admin.email}</div></td>
                    <td>
                      <label className="Sub-Admin-SubAdmin-toggle">
                        <input type="checkbox" checked={isActive} onChange={() => toggleStatus(admin.id, isActive)} />
                        <span className="Sub-Admin-SubAdmin-toggle-slider"></span>
                      </label>
                    </td>
                    <td>
                      <div className="Sub-Admin-SubAdmin-actions">
                        <button className="Sub-Admin-SubAdmin-btn-icon-action Sub-Admin-SubAdmin-btn-edit"   onClick={() => onEdit(admin)}           title="Edit">✏️</button>
                        <button className="Sub-Admin-SubAdmin-btn-icon-action Sub-Admin-SubAdmin-btn-delete" onClick={() => deleteSubAdmin(admin.id)} title="Delete">🗑️</button>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr><td colSpan="5" className="Sub-Admin-SubAdmin-no-data">No sub-admins found</td></tr>
            )}
          </tbody>
        </Table>
      </div>

      {totalPages > 1 && (
        <div className="Sub-Admin-SubAdmin-pagination">
          <div className="Sub-Admin-SubAdmin-pagination-info">
            Showing {startIndex + 1} to {Math.min(startIndex + itemsPerPage, filteredAdmins.length)} of {filteredAdmins.length} results
          </div>
          <Pagination className="Sub-Admin-SubAdmin-pagination-buttons" size="sm">
            <Pagination.Prev onClick={() => setCurrentPage((p) => Math.max(1, p - 1))} disabled={currentPage === 1} />
            {getPageNumbers().map((page, idx) => (
              <Pagination.Item key={idx} active={currentPage === page} disabled={page === '...'} onClick={() => typeof page === 'number' && setCurrentPage(page)}>{page}</Pagination.Item>
            ))}
            <Pagination.Next onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages} />
          </Pagination>
        </div>
      )}
    </div>
  );
};


// ================================================================
//  MAIN — SubAdminManagement
// ================================================================
const SubAdminManagement = () => {


  const [currentView, setCurrentView]     = useState('list');

  const [selectedAdmin, setSelectedAdmin] = useState(null);

  const handleAddNew = () => setCurrentView('add');
  const handleEdit   = (admin) => { setSelectedAdmin(admin); setCurrentView('edit'); };
  const handleBack   = () => { setCurrentView('list'); setSelectedAdmin(null); };

  return (
    <div className="Sub-Admin-SubAdmin-management-wrapper">
      {currentView === 'list' && <SubAdminList onEdit={handleEdit} onAdd={handleAddNew} />}
      {currentView === 'add'  && <SubAdminAdd  onBack={handleBack} onSave={handleBack} />}
      {currentView === 'edit' && <SubAdminEdit admin={selectedAdmin} onBack={handleBack} onSave={handleBack} />}
    </div>
  );
};

export default SubAdminManagement;
export { SubAdminList, SubAdminAdd, SubAdminEdit };